import React from "react";
import axios from "axios";
import { Button, Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

function Header() {
  const url = "https://goadmin.ifrc.org/api/v2/appeal/aggregated/?country=194";

  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.get(url).then((response) => {
      setPost(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!post) return null;

  return (
    <section id="services" className="bg-lighter">
      <div className="container pb-0">
        <div className="section-title text-center mb-20">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 className="font-weight-700 text-uppercase">МОНГОЛ УЛС</h2>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container p-0 p-sm-15">
          <div class="section-content">
            <div className="row equal-height-inner home-boxes">
              <div className="col-md-12 table">
                <table className="table">
                  <tr>
                    <td>
                      <div className=" mb-0 border-0px">
                        <div className="p-15 pt-20 pb-10">
                          <img src="images/1.svg" alt="" />
                          <h2 className="font-weight-700 text-uppercase">
                            {post.active_drefs}
                          </h2>
                          <h5 className="font-14 font-weight-500 mb-5">
                            Active DREF Operations
                            <span className="iconfloat">
                              <Popover
                                overlayStyle={{
                                  width: "25vw",
                                }}
                                content={
                                  "These are small to medium scale emergency operations funded through the Disaster Relief Emergency Fund (DREF).The DREF provides immediate financial support to National Red Cross and Red Crescent Societies, enabling them to carry out their unique role as first responders after a disaster."
                                }
                                title="DREF"
                              >
                                <Button
                                  shape="circle"
                                  icon={<InfoCircleOutlined />}
                                />
                              </Popover>
                            </span>
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className=" mb-0 border-0px">
                        <div className="p-15 pt-20 pb-10">
                          <img src="images/2.svg" alt="" />
                          <h2 className="font-weight-700 text-uppercase">
                            {post.active_appeals}
                          </h2>
                          <h5 className="font-14 font-weight-500 mb-5">
                            Active Emergency Appeals
                            <span className="iconfloat">
                              <Popover
                                overlayStyle={{
                                  width: "20vw",
                                }}
                                content={
                                  "These are medium to large scale emergency operations funded through a public appeal for funds."
                                }
                                title="Emergency Appeal"
                              >
                                <Button
                                  shape="circle"
                                  icon={<InfoCircleOutlined />}
                                />
                              </Popover>
                            </span>
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className=" mb-0 border-0px">
                        <div className="p-15 pt-20 pb-10">
                          <img src="images/3.svg" alt="" />
                          <h2 className="font-weight-700 text-uppercase">
                            {post.amount_requested_dref_included == null && 0}
                          </h2>
                          <h5 className="font-14 font-weight-500 mb-5">
                            Funding requirements (CHF
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className=" mb-0 border-0px">
                        <div className="p-15 pt-20 pb-10">
                          <img src="images/4.svg" alt="" />
                          <h2 className="font-weight-700 text-uppercase">
                            {post.amount_funded == null && 0}
                          </h2>
                          <h5 className="font-14 font-weight-500 mb-5">
                            Funding coverage
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className=" mb-0 border-0px">
                        <div className="p-15 pt-20 pb-10">
                          <img src="images/5.svg" alt="" />
                          <h2 className="font-weight-700 text-uppercase">
                            {post.target_population == null && 0}
                          </h2>
                          <h5 className="font-14 font-weight-500 mb-5">
                            Targeted population
                          </h5>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

export default Header;
